<modal *ngIf="!useSourceCredentials" [name]="localStorageKeys.ti_modal_simple_credentials_prompt" [minWidth]="350" (closeOut)="cancel()">
  <modal-header>
    <span class="title">{{ estrings.pleaseProvideYourCredentials }}</span>
  </modal-header>
  <modal-body>
    <div class="control">
      <!--
      <ng-container *ngIf="additionalText">
        <label>{{ estrings.certifiedCopyReason }}</label>
        <span>{{additionalText}}</span>
      </ng-container>
      -->
      <div *ngIf="errorMessage"><label class="error">{{errorMessage}}</label></div>
      <label class="required" for="username">{{ estrings.username }}</label>
      <input id="username" [required]="true" kendotextbox class="simple-auth-text-input k-textbox w-100" [(ngModel)]="loginName">
      <label class="required" for="password">{{ estrings.password }}</label>
      <input id="password" type="password" (keydown.enter)="ok()" [required]="true" kendotextbox class="k-textbox w-100" [(ngModel)]="password">
    </div>
  </modal-body>
  <modal-actions>
    <button kendoButton fillMode="solid" themeColor="tertiary" (click)="cancel()">{{ strings.cancel }}</button>
    <button kendoButton (click)="ok()" [primary]="true" [disabled]="!loginName || !password">{{ strings.ok }}</button>
  </modal-actions>

  <ti-spinner *ngIf="loading"></ti-spinner>
</modal>
